export const subscriptionConfig = Object.freeze({
  Basic: {
    allowNotifications: true,
    allowMessages: true,
    allowStudentAttendanceReport: true,
    allowStaffAttendanceReport: true,
    allowProgression: true,
    allowFeeRecords: true,
    allowStudentAdmitCard: true,
    allowStudentBonafide: true,
    allowStudentMarksheet: true,
    allowStudentTransferCertificate: true,
    allowStudentPhoto: false,
    allowStudentIdCard: false,
    allowStaffPhoto: false,
    allowStaffIdCard: false,
    allowStaffJoiningLetter: true,
    allowStaffExperienceLetter: true,
    allowPayroll: false,
    allowSchoolUsers: false,
    allowStaffLogin: false,
    allowStudentLogin: false,
    allowParentLogin: false,
    allowStudentAttendanceReportExport: false,
    allowStaffAttendanceReportExport: false,
    allowTransport: false,
    allowLibrary: false,
    allowBulkFeeReminders: false,
  },
  Standard: {
    allowNotifications: true,
    allowMessages: true,
    allowStudentAttendanceReport: true,
    allowStaffAttendanceReport: true,
    allowProgression: true,
    allowFeeRecords: true,
    allowStudentAdmitCard: true,
    allowStudentBonafide: true,
    allowStudentMarksheet: true,
    allowStudentTransferCertificate: true,
    allowStudentPhoto: true,
    allowStudentIdCard: true,
    allowStaffPhoto: true,
    allowStaffIdCard: true,
    allowStaffJoiningLetter: true,
    allowStaffExperienceLetter: true,
    allowPayroll: true,
    allowSchoolUsers: true,
    allowStaffLogin: true,
    allowStudentLogin: false,
    allowParentLogin: false,
    allowStudentAttendanceReportExport: true,
    allowStaffAttendanceReportExport: true,
    allowTransport: false,
    allowLibrary: false,
    allowBulkFeeReminders: false,
  },
  Premium: {
    allowNotifications: true,
    allowMessages: true,
    allowStudentAttendanceReport: true,
    allowStaffAttendanceReport: true,
    allowProgression: true,
    allowFeeRecords: true,
    allowStudentAdmitCard: true,
    allowStudentBonafide: true,
    allowStudentMarksheet: true,
    allowStudentTransferCertificate: true,
    allowStudentPhoto: true,
    allowStudentIdCard: true,
    allowStaffPhoto: true,
    allowStaffIdCard: true,
    allowStaffJoiningLetter: true,
    allowStaffExperienceLetter: true,
    allowPayroll: true,
    allowSchoolUsers: true,
    allowStaffLogin: true,
    allowStudentLogin: true,
    allowParentLogin: true,
    allowStudentAttendanceReportExport: true,
    allowStaffAttendanceReportExport: true,
    allowTransport: true,
    allowLibrary: true,
    allowBulkFeeReminders: true,
  },
  // Enterprise: {
  //   allowPayroll: true,
  // },
});

export const hasSubscriptionFeature = (featureTier, feature) =>
  Boolean(subscriptionConfig[featureTier || "Basic"]?.[feature]);
